import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-09-26 18:19:22
 * @LastEditTime: 2022-01-13 14:40:03
 * @LastEditors: wangshengqiang
 * @Description: 终保日期 安澜项目新增
 */
import React, { useEffect } from 'react';
import { useStore } from '@/store';
import { getStatePath } from '@/utils/utils.js';
import { addDay, addMonth, addYear, formatDate } from '@/utils/tool.js';
import moment from 'moment';
import RowDate from '../RowDate';

function getNewDate(start, period) {
  if (start && period) {
    const [diff, type] = period.split('-');

    if (type === 'D') {
      return addDay(start, diff);
    }

    if (type === 'M') {
      return addMonth(start, diff);
    }

    if (type === 'Y') {
      return addYear(start, diff);
    }
  }
}

export default function InsureEndDate(props) {
  const {
    attrs,
    formKey,
    form
  } = props;
  const startDateValuePath = getStatePath(formKey, 'insuranceStartDate');
  const insurancePeriodValuePath = getStatePath(formKey, 'insurancePeriod');
  const insuranceStartDateValue = useStore(`formValues.${startDateValuePath}`);
  const insurancePeriodValue = useStore(`formValues.${insurancePeriodValuePath}`);
  useEffect(() => {
    if (insuranceStartDateValue && insurancePeriodValue) {
      const dd = getNewDate(insuranceStartDateValue, insurancePeriodValue);
      form.setFieldsValue({
        [formKey]: formatDate(dd)
      });
    }
  }, [insuranceStartDateValue, insurancePeriodValue]);
  const min = moment().add(1, 'days').format('YYYY-MM-DD');
  const max = moment().add(80, 'years').format('YYYY-MM-DD');
  return /*#__PURE__*/React.createElement(RowDate, _extends({}, props, {
    min: min,
    max: max,
    disabled: insuranceStartDateValue && insurancePeriodValue
  }));
}